/*
 * @Description: 照片、录音预览组件
 * @Author: fengd
 * @LastEditors: fengd
 * @Date: 2019-03-22 16:17:07
 * @LastEditTime: 2019-09-02 11:04:54
 */
import React from 'react';
import bgImg from '../../assets/imgs/bg-audio.png';
import staticIcon from '../../assets/imgs/audio.png';
import gifIcon from '../../assets/imgs/audio.gif';
import './preview.scss';
import Icon from '../icon/Icon';

export function Image(props) {
  return (
    <div className="preview-image">
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <img src={props.url} alt="照片" className="preview-image-img" onClick={() => props.onShow('img', props)} />
      {
        props.noDelete ? '' : (
          <span className="preview-close" onClick={() => props.onDelete('img', props.id)}>
            <Icon
              icon="cuo"
              className="preview-close-icon"
              style={props.closeStyle}
            />
          </span>
        )
      }
    </div>
  );
}

export function Audio(props) {
  const styles = Object.assign({
    background: `url(${bgImg}) no-repeat center`,
    backgroundSize: '100% 100%'
  }, props.style);
  const staticAudio = props.hornIcon || staticIcon;
  const gifAudio = props.hornGif || gifIcon;

  return (
    <div
      className={['preview-audio', props.className].join(' ')}
      role="button"
      tabIndex={0}
      onClick={() => props.onPlayAudio('audio', props)}
      style={styles}
    >
      {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
      <span className="preview-audio-text">{(props.duration / 1000).toFixed(2)}s</span>
      <span className="preview-audio-icon">
        <img src={props.currentPlayId === props.id ? gifAudio : staticAudio} alt="closeIcon" />
      </span>
      <span className="preview-close" onClick={() => props.onDelete('audio', props.id)}>
        <Icon
          icon="cuo"
          className="preview-close-icon"
          style={props.closeStyle}
        />
      </span>
    </div>
  );
}
